<div class="container container-shadow pt-4 pb-5 my-4 mb-4">
  <h3 class="text-center">Stylesheets</h3>
  <div class="row m-2">
    <div class="col-md-12">
      <div class="form-group">
        <label for="stylsheet-name">Stylesheet Name</label>
        <input type="text" class="form-control" id="stylsheet-name" list="stylesheets" [(ngModel)]="styleSheetNameInput" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" (input)="navigateToEdit()" />
        <datalist id="stylesheets" *ngIf="shouldAutoComplete">
          <option *ngFor="let stylesheet of stylesheets">{{ stylesheet.name }}</option>
        </datalist>
      </div>
      <div class="form-group">
        <label for="stylesheet-content">Stylesheet Content</label>
        <textarea class="form-control" id="stylesheet-content" rows="7" [(ngModel)]="styleSheetContentInput" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" placeholder="Stylesheet content goes here"></textarea>
      </div>
      <div class="form-group">
        <label for="stylesheet-group-select">Stylesheet Group</label>
        <select class="form-control" id="styleshhet-group-select" [(ngModel)]="styleSheetGroupInput" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }">
          <option>None</option>
          <option *ngFor="let stylesheetGroup of stylesheetGroups" value="{{ stylesheetGroup.id }}">{{ stylesheetGroup.name }}</option>
        </select>
      </div>
      <button type="button" class="btn btn-primary" (click)="styleSheetId ? updateStyleSheet() : createStyleSheet()" [disabled]="isSubmitting">
        {{ isSubmitting ? 'Submitting' : 'Submit' }}<span *ngIf="isSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
      >&nbsp;<a type="button" class="btn btn-light" routerLink="/stylesheets" routerLinkActive="active">Cancel</a>
    </div>
  </div>
  <div class="row m-2" style="margin: auto">
    <div class="col-md-12">
      <iframe width="100%" height="400px" id="stylesheet-preview"></iframe>
    </div>
  </div>
</div>
